import React from 'react';
import { observer } from 'mobx-react-lite';
import '../SelectedHistory.scss';
import { tableBetHistoryStore, useTranslation } from '@pascal/pascal-core';
import { cardsStore } from '../../../store/cardsStore';
import { CARDS_TYPE, CUTTING_CARD } from '../../../enums/cardTypes';
import { BET_TYPES_NAMES, OWNER_BET_TYPE_T_KEYS, OWNER_T_KEYS } from '../../../enums/cardOwner';

export const SelectedRow = observer(() => {
  const { thirdStep } = tableBetHistoryStore;
  const t = useTranslation();
  const { selectedCardType } = cardsStore;
  const { data: thirdStepData } = thirdStep;
  return (
    <div className='none-stop-bet-history-container'>
      <div className='none-stop-bet-history-group'>
        <div className='none-stop-bet-history-row head'>
          <div className='none-stop-bet-history-column'>
            <span className='none-stop-bet-history-text'>{t(OWNER_T_KEYS.HomeWin)}</span>
          </div>
          <div className='none-stop-bet-history-column'>
            <span className='none-stop-bet-history-text'>{t(OWNER_T_KEYS.AwayWin)}</span>
          </div>
          <div className='none-stop-bet-history-column'>
            <span className='none-stop-bet-history-text'>{t('RESULT')}</span>
          </div>
        </div>
        <div className='none-stop-bet-history-row'>
          {thirdStepData.roundData &&
            thirdStepData.roundData.cards.map(({ side, card }) => {
              if (card === CUTTING_CARD) return null;
              return (
                <div key={side} className='none-stop-bet-history-column'>
                  <div
                    className={`none-stop-bet-history-card ${selectedCardType} ${CARDS_TYPE[card]}`}
                  />
                </div>
              );
            })}
          <div className='none-stop-bet-history-column'>
            <span className='none-stop-bet-history-text yellow'>
              {t(OWNER_BET_TYPE_T_KEYS[BET_TYPES_NAMES[thirdStepData.roundData.winType]])}
            </span>
          </div>
        </div>
      </div>
      <div className='none-stop-bet-history-group'>
        <div className='none-stop-bet-history-row head'>
          <div className='none-stop-bet-history-column'>
            <span className='none-stop-bet-history-text'>{t('TYPE')}</span>
          </div>
          <div className='none-stop-bet-history-column'>
            <span className='none-stop-bet-history-text'>{t('BET')}</span>
          </div>
          <div className='none-stop-bet-history-column'>
            <span className='none-stop-bet-history-text'>{t('WIN')}</span>
          </div>
        </div>
        {thirdStepData.additionalParams &&
          thirdStepData.additionalParams.map(({ name, amount, winAmount }) => (
            <div key={name} className='none-stop-bet-history-row'>
              <div className='none-stop-bet-history-column'>
                <span className='none-stop-bet-history-text'>{t(OWNER_T_KEYS[name])}</span>
              </div>
              <div className='none-stop-bet-history-column'>
                <span className='none-stop-bet-history-text'>
                  {amount} {thirdStepData?.freeBetId ? `(${t('FREE_CHIP')})` : ''}
                </span>
              </div>
              <div className='none-stop-bet-history-column'>
                <span className='none-stop-bet-history-text yellow'>{winAmount}</span>
              </div>
            </div>
          ))}
        <div className='none-stop-bet-history-row total'>
          <div className='none-stop-bet-history-column'>
            <span className='none-stop-bet-history-text'>{t('TOTAL')}</span>
          </div>
          <div className='none-stop-bet-history-column'>
            <span className='none-stop-bet-history-text'>{thirdStepData.amount}</span>
          </div>
          <div className='none-stop-bet-history-column'>
            <span className='none-stop-bet-history-text'>{thirdStepData.winAmount}</span>
          </div>
        </div>
      </div>
    </div>
  );
});
